module.exports = __webpack_public_path__ + "img/logo.f743ea15.png";